jQuery(function ($) {
  $(".tools-and-materials__show-more--products").on("click", function () {
    $(".tools-and-materials__product.mobile-hidden").fadeIn(
      "fast",
      function () {
        $(this).removeClass("mobile-hidden");
      }
    );
    $(this).hide();
  });

  $(".tools-and-materials__show-more--items").on("click", function () {
    $(".tools-and-materials__item.mobile-hidden").fadeIn("fast", function () {
      $(this).removeClass("mobile-hidden");
    });
    $(this).hide();
  });
});
